import { createEvent, createStore } from "effector";
import { resetControlsSource } from "../models";

export const setMobileControlsVisibility = createEvent<boolean>();

export const $mobileControlsVisible = createStore(true)
  .on(setMobileControlsVisibility, (_, visible) => visible)
  .reset(resetControlsSource);
